import { Card, CardHeader, CardTitle } from '@progress/kendo-react-layout'
import React from 'react'

import { VStack } from '~/components/elements/VStack'

export type DataSettingsCardProps = React.PropsWithChildren<{
  title: string
}>

export const DataSettingsCard = ({
  children,
  title,
}: DataSettingsCardProps) => (
  <Card>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
    </CardHeader>

    <VStack padding={4} spacing={4}>
      {children}
    </VStack>
  </Card>
)
